import { Injectable } from '@angular/core'
import { doc, DocumentReference, Firestore, serverTimestamp, setDoc } from '@angular/fire/firestore'
import { trackingEntriesPath, TrackingEntryType } from '@parkupp/core'

@Injectable({
    providedIn: 'root',
})
export class TrackingService {
    constructor(public firestore: Firestore) {}

    async addEntry(type: TrackingEntryType, parkingRef: DocumentReference, userId?: string) {
        const parkingId = parkingRef.id // Assuming parkingRef is a Firestore DocumentReference
        const today = new Date().toISOString().split('T')[0] // Get today's date in 'YYYY-MM-DD' format
        const docId = `${today}-${userId}-${type}-${parkingId}`

        const trackingEntriesRef = doc(this.firestore, trackingEntriesPath(), docId)

        const trackingEntryData = {
            type: type,
            parkingRef: parkingRef,
            createdAt: serverTimestamp(),
            userId: userId,
        }

        // This will either create a new document or overwrite an existing one
        await setDoc(trackingEntriesRef as any, trackingEntryData)

        // console.log(`Entry of type ${type} for user ${userId} and parking ID ${parkingId} saved or updated for today.`)
    }
}
